module.exports = __webpack_public_path__ + "static/media/Vendas7.6523e030.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancVendas/Vendas7.png
// module id = 1777
// module chunks = 0